const onboarding = {
  title: "Welcome to",
  titleHighlight: "Yoram",
  description:
    "Easily view, manage, and track all your scheduled events in one centralized dashboard, designed to give you real-time clarity & control over your operations.",
  getStarted: "Get Started",
};

export default onboarding;
